var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left tool-bar"},[_c('span',{staticClass:"button",on:{"click":_vm.getArea}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.icon5,"alt":""}})]),_c('span',[_vm._v(" 导出区域信息 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }